const clone = (value) => (Array.isArray(value) ? [...value] : value)

export const SETTINGS_FIELDS = {
  inputPhone: { default: 'default' },
  outputPhone: { default: 'default' },
  additionalDevice: { default: 'default' },
  locationSummaryAgent: { default: 'topo' },
  groupQuickAnswers: { default: 'yes' },
  groupMinPerfilator: { default: 'no' },
  windowToForeground: { default: 'no' },
  notificationStyle: { default: 'popup' },
  autoPlayback: { default: 'yes' },
  autoAlertVolume: { default: 100 },

  useDND: {
    default: 'no',
    flag: 'canUseDND'
  },

  dndOptionsList: {
    default: ['TEXT', 'VOICE', 'MAIL'],
    flag: 'canUseDND',
    requires: ({ useDND }) => useDND === 'yes'
  },

  dndCallTypes: {
    default: 'ALL',
    flag: 'canUseDND',
    requires: ({ useDND, dndOptionsList }) => useDND === 'yes' && asList(dndOptionsList).includes('VOICE')
  }
}

export const SETTINGS_NAMES = Object.keys(SETTINGS_FIELDS)

export const ungatedDefaults = () => SETTINGS_NAMES.reduce((defaults, name) => {
  const { flag, default: value } = SETTINGS_FIELDS[name]
  if (!flag) defaults[name] = clone(value)
  return defaults
}, {})

export const settingValue = (state, name) => state?.[name] ?? clone(SETTINGS_FIELDS[name]?.default)

export const isFieldVisible = (name, { flag, values }) => {
  const field = SETTINGS_FIELDS[name]
  if (!field) return false
  if (field.flag && flag(field.flag) !== true) return false
  return field.requires ? Boolean(field.requires(values)) : true
}

export const visibleFieldNames = (context) => SETTINGS_NAMES.filter((name) => isFieldVisible(name, context))

const asList = (value) => (Array.isArray(value) ? value : [])
